import React, { useEffect, useCallback, useState, useRef } from 'react';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
  Alert,
  AlertIcon,
	VStack,
} from '@chakra-ui/react';
import { FiMail, FiLock, FiEye, FiEyeOff } from 'react-icons/fi';
import { MdFace } from "react-icons/md";
import { v4 as uuid } from 'uuid';

import api from '../../../services/api';
import { useToast } from '../../../hooks/toast';
import getValidationErrors from '../../../utils/getValidationErrors';
import Input from '../../Inputs/Input';
import { AppError } from '../../../utils/AppError';

import {
  Container,
  Content,
  Header,
  FormView,
  ButtonsView,
  TabNameMail,
  TabResumo,
} from './styles';

type AcessoDATA = {
	id: string;
	nome: string;
	email: string;
	password: string;
	role: string;
	status: string;
}
interface ModalPARAMS {
  id?: string;
  onClose: any;
  isVisible: boolean;
	acesso: AcessoDATA;
  handleAcesso: (access: AcessoDATA) => Promise<void>;
}

const ModalAcesso: React.FC<ModalPARAMS> = ({
  onClose = () => {},
  isVisible,
	acesso,
  handleAcesso
}) => {
  const handleOnClose = useCallback(() => {
    formRef.current?.reset();
    setVisible(false);
    setTimeout(() => {
      onClose();
    }, 300);
  }, [onClose]);

  const formRef = useRef<FormHandles>(null);

  const { addToast } = useToast();
  const [visible, setVisible] = useState(isVisible);

  const [tabIndex, setTabIndex] = useState(0);
	const [disableTab1, setDisableTab1] = useState(true);

	const [newAcesso, setNewAcesso] = useState<AcessoDATA>({} as AcessoDATA);

  const [messageVisible, setMessageVisible] = useState(false);
  const [message, setMessage] = useState('');

	const [showPassword, setShowPassword] = useState(false);
	const [showConfirmPassword, setShowConfirmPassword] = useState(false);

	async function handleVerifAcesso(form: any) {
		try {
			setMessageVisible(false);
			setMessage('');
			if (!form.email || form.nome) {
				await handleSubmitPrimeiro(form);
				return;
			}

			const { data } = await api.post('/portal/user/verif', { email: form.email });

			if (data.stat === 'E') {
				setMessage(data.mensagem);
				setMessageVisible(true);
				return;
			}

			if (data.stat === 'S') {
				setMessage('Este e-mail já existe cadastrado, por favor escolha outro e-mail!');
				setMessageVisible(true);
				return;
			}

			await handleSubmitPrimeiro(form);
		}
		catch (error) {
			const isAppError = error instanceof AppError;
			const msg = isAppError ? error.message : 'Não foi possível verificar o acesso.';

			addToast({
				type: 'error',
				title: 'Verificar Acesso!',
				description: msg,
			});
		}
	};

	async function handleSubmitPrimeiro(form: any) {
		try {
			formRef.current?.setErrors({});

			const schema = Yup.object().shape({
				nome: Yup.string().required('Nome é obrigatório'),
				email: Yup.string().required('E-mail é obrigatório'),
				password: Yup.string()
					.min(6, 'No minimo 6 dígitos')
					.required('Senha é obrogatória!'),
				confirmPassword: Yup.string()
					.when('password', {
						is: (val: string) => !!val.length,
						then: Yup.string().required('Campo obrigatório.'),
						otherwise: Yup.string(),
					})
					.oneOf([Yup.ref('password'), undefined], 'Senhas não conferem.'),
			});

			await schema.validate(form, { abortEarly: false });

			const { nome, email, password } = form;
			const auxAcesso: AcessoDATA = {
				id: uuid(),
				nome,
				email,
				password,
				role: 'admin',
				status: 'S',
			};
			setNewAcesso({ ...auxAcesso });

			setDisableTab1(false);
			setTabIndex(1);
		} catch (error) {
			if (error instanceof Yup.ValidationError) {
				const errors = getValidationErrors(error);
				formRef.current?.setErrors(errors);
				return;
			}

			const isAppError = error instanceof AppError;
			const msg = isAppError ? error.message : 'Não foi salvar dados do acesso.';

			addToast({
				type: 'error',
				title: 'Dados do Acesso',
				description: msg,
			});
		}
  };

	async function handleSubmit() {
		try {
			await handleAcesso(newAcesso);
		}
		catch (error) {
			const isAppError = error instanceof AppError;
			const msg = isAppError ? error.message : `Não foi possível salvar novo acesso.`;

			addToast({
				type: 'error',
				title: `Novo Acesso!`,
				description: msg,
			});
		}
		finally {
			handleOnClose();
		}
  };

	async function handleCancel() {
		// handleAcesso();
		handleOnClose();
		formRef.current?.reset();
	}

  return (
    <Container id="modalPerfilAcesso">
      <Content className={`${visible ? 'active' : ''}`}>
				<Tabs className="tabs" index={tabIndex}>
					<TabList className="tab-list">
						<Tab className="tab" onClick={() => setTabIndex(0)}>
							Passo 1
						</Tab>

						<Tab
							className="tab"
							isDisabled={disableTab1}
							onClick={() => {
								if (tabIndex === 0)
									handleVerifAcesso(formRef.current?.getData());
								else
									setTabIndex(1);
							}}
						>
							Passo 2
						</Tab>
					</TabList>

					<TabPanels className="tab-panels">
						<TabNameMail className="tab-panel">
							<Header>
								<h1>Criar Acesso</h1>
								<h2>Digite aos dados do usuário para criar o acesso.</h2>
							</Header>

							{messageVisible && (
								<Alert
									status="error"
									style={{
										marginTop: '10px',
										marginBottom: '10px',
										borderRadius: '10px',
									}}
								>
									<AlertIcon />
									{message}
								</Alert>
							)}

							<FormView
								id="form-nome-email"
								ref={formRef}
								initialData={acesso}
								onSubmit={handleVerifAcesso}
							>
								<div className="input">
									<p>Nome <span>(obrigatório)</span></p>
									<Input
										name="nome"
										type="text"
										placeholder="Nome de usuário"
										icon={MdFace}
									/>
								</div>

								<div className="input">
									<p>E-mail <span>(obrigatório)</span></p>
									<Input
										name="email"
										type="email"
										placeholder="Email de acesso"
										icon={FiMail}
									/>
								</div>

								<VStack id="inputs-password">
									<div className="input">
										<p>Senha <span>(obrigatório)</span></p>
										<Input
											name="password"
											type={showPassword ? "text" : "password"}
											placeholder="Senha"
											icon={FiLock}
											iconInputRight={{
												IconRight: showPassword ? FiEyeOff : FiEye,
												showPassword,
												setShowPassword
											}}
										/>
									</div>

									<div className="input">
										<p>Confirmar Senha <span>(obrigatório)</span></p>
										<Input
											name="confirmPassword"
											type={showConfirmPassword ? "text" : "password"}
											placeholder="Confirmar Senha"
											icon={FiLock}
											iconInputRight={{
												IconRight: showConfirmPassword ? FiEyeOff : FiEye,
												showPassword: showConfirmPassword,
												setShowPassword: setShowConfirmPassword
											}}
										/>
									</div>
								</VStack>

								<ButtonsView>
									<button
										className="btn-cancel"
										type="button"
										onClick={handleCancel}
									>
										Cancelar
									</button>

									<button className="btn-save" type="submit">
										Proximo
									</button>
								</ButtonsView>
							</FormView>
						</TabNameMail>

						<TabResumo className="tab-panel">
							<Header>
								<h1>Resumo</h1>
								<h2>Confirme as informações que você informou.</h2>
							</Header>

							<hr />

							<div className="item">
								<h1>Nome do usuário</h1>
								<h2>{newAcesso.nome}</h2>
							</div>

							<div className="item">
								<h1>Email de acesso</h1>
								<h2>{newAcesso.email}</h2>
							</div>

							<div className="item">
								<h1>Perfil</h1>
								<h2>Administrador</h2>
							</div>

							<ButtonsView>
								<button
									className="btn-cancel"
									type="button"
									onClick={() => setTabIndex(0)}
								>
									Voltar
								</button>
								<button className="btn-save" onClick={handleSubmit}>
									Cadastrar
								</button>
							</ButtonsView>
						</TabResumo>
					</TabPanels>
				</Tabs>
      </Content>
    </Container>
  );
};

export default ModalAcesso;
